<script>
    export default {
        data() {
            return {
                filterMutable: null,
                url: '',
                flatpickr: {
                  start: {
                    minDate: null,
                    maxDate: null
                  },
                  end: {
                    minDate: null
                  },
                  vt: {
                    maxDate: null
                  },
                },
            }
        },

        created() {
          this.filterMutable = _.merge({
            category: null,
            textStatus: null,
            productTexter: null,
            activity: null,
            season: null,
            campaign: null,
            shopActive: null,
            client: null,
            workingPage: null,
            articleNr: null,
            productGroup: null,
            productMainGroup: null,
            productName: null,
            suffix: null,
            newFlagDe: null,
            setFlag: null,
            nosFlag: null,
            hasComment: null,
            autosortLock: null,
            noFirstImage: null,
            selected: null,
            isSustainable: null,
            onlineSince: null,
            newSince: null,
          }, this.filter);
        },

        mounted() {
          window.formElementRelations.inputsRegistered();
          this.url = new URI(window.location.href);
        },

        props: {
            filter: {}
        },

        methods: {
            search() {
                _.each(this.filterMutable, (filterInput, key) => {
                    this.url.removeQuery('reset');
                    this.url.removeQuery('page');
                    this.url.removeQuery(key);

                    if (filterInput instanceof Object) {
                        this.url.addQuery(key, filterInput.value);
                    } else if (filterInput !== 0 && filterInput !== null) {
                        if (filterInput === 'false' || filterInput === false) {
                            this.url.removeQuery(key);
                        } else if (filterInput === 'true' || filterInput === true) {
                            this.url.addQuery(key, 1);
                        } else {
                            this.url.addQuery(key, filterInput);
                        }
                    }
                });

              this.url.addQuery('page', 1);
              window.location.href = this.url.toString();
            },

            reset() {
                _.each(this.filterMutable, (value, key) => {
                    this.url.removeQuery(key);
                });

                this.url.addQuery('reset', 'true');
                window.location.href = this.url.toString();
            },

            selectCategory(category_id) {
                this.filterMutable.category = category_id;
                this.search();
            },

            setTextStatus(input) {
                this.filterMutable.textStatus = null;
                if (input) {
                    this.filterMutable.textStatus = input.selectedObject;
                }
            },

            setProductTexter(input) {
                this.filterMutable.productTexter = null;
                if (input) {
                    this.filterMutable.productTexter = input.selectedObject;
                }
            },

            setActivity(input) {
                this.filterMutable.activity = null;
                if (input) {
                    this.filterMutable.activity = input.selectedObject;
                }
            },

            setSeason(input) {
              this.filterMutable.season = null;

              if (input) {
                this.filterMutable.season = input.selectedObject;
              }
            },

            setCampaign(input) {
                this.filterMutable.campaign = null;
                if (input) {
                    this.filterMutable.campaign = input.selectedObject;
                }
            },

            setShopActive(input) {
                this.filterMutable.shopActive = null;
                if (input) {
                    this.filterMutable.shopActive = input.selectedObject;
                }
            },

            setClient(input) {
                this.filterMutable.client = null;
                if (input) {
                    this.filterMutable.client = input.selectedObject;
                }
            },

            onStartChange: function (selectedDates, dateStr) {
              this.$set(this.flatpickr.end, 'minDate', dateStr);
              this.$set(this.flatpickr.vt, 'maxDate', dateStr);
            },

            onEndChange: function (selectedDates, dateStr) {
              this.$set(this.flatpickr.start, 'maxDate', dateStr);
            },
        }
    }
</script>

<template>
    <div>
        <div class="row">
            <div class="col-lg-3 m-b-sm">
                <div class="row">
                    <div class="col-xs-6">
                        <label class="block">
                            <h5>Kampagne</h5>
                        </label>
                        <interactive-select
                                name="campaign"
                                element-name="campaign"
                                select-value="id"
                                select-label="name"
                                @update:value="setCampaign"
                                :value="filterMutable.campaign"
                        ></interactive-select>
                    </div>
                    <div class="col-xs-2">
                        <label class="block">
                            <h5>AS</h5>
                            <input type="text" class="form-control full-width" v-model="filterMutable.workingPage"
                                   @keyup.enter="search">
                        </label>
                    </div>
                    <div class="col-xs-4">
                      <label class="block">
                        <h5>Online ab</h5>
                      </label>
                      <flat-pickr class="form-control"
                                  :config="flatpickr.start"
                                  v-model="filterMutable.onlineSince"
                                  @on-change="onStartChange">
                      </flat-pickr>
                    </div>
                    <div class="col-xs-4">
                      <label class="block">
                        <h5>Neu ab</h5>
                      </label>
                      <flat-pickr class="form-control"
                                  :config="flatpickr.start"
                                  v-model="filterMutable.newSince"
                                  @on-change="onStartChange">
                      </flat-pickr>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>ArtikelNr</h5>
                    <input type="text" class="form-control full-width" v-model="filterMutable.articleNr"
                           @keyup.enter="search">
                </label>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Activity</h5>
                </label>
                <interactive-select
                        name="activity"
                        element-name="activity"
                        select-value="id"
                        select-label="name"
                        @update:value="setActivity"
                        :value="filterMutable.activity"
                ></interactive-select>
            </div>
            <div class="col-lg-3 m-b-sm">
              <label class="block">
                <h5>Saisonzuordnung</h5>
              </label>
              <interactive-select
                  name="season"
                  element-name="season"
                  select-value="id"
                  select-label="text"
                  @update:value="setSeason"
                  :value="filterMutable.season"
              ></interactive-select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Produktgruppe</h5>
                    <input type="text" class="form-control full-width" v-model="filterMutable.productGroup"
                           @keyup.enter="search">
                </label>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Produkthauptgruppe</h5>
                    <input type="text" class="form-control full-width" v-model="filterMutable.productMainGroup"
                           @keyup.enter="search">
                </label>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Produktname</h5>
                    <input type="text" class="form-control full-width" v-model="filterMutable.productName"
                           @keyup.enter="search">
                </label>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Suffix</h5>
                    <input type="text" class="form-control full-width" v-model="filterMutable.suffix"
                           @keyup.enter="search">
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>eShop aktiv</h5>
                </label>
                <interactive-select
                        name="shopActive"
                        element-name="shopActive"
                        select-value="id"
                        select-label="name"
                        @update:value="setShopActive"
                        :value="filterMutable.shopActive"
                ></interactive-select>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Textstatus</h5>
                </label>
                <interactive-select
                        name="productTextStatus"
                        element-name="productTextStatus"
                        select-value="id"
                        select-label="name"
                        @update:value="setTextStatus"
                        :value="filterMutable.textStatus"
                ></interactive-select>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Texter</h5>
                </label>
                <interactive-select
                        name="productTexter"
                        element-name="productTexter"
                        select-value="user_id"
                        select-label="fullName"
                        @update:value="setProductTexter"
                        :value="filterMutable.productTexter"
                ></interactive-select>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Mandanten</h5>
                </label>
                <interactive-select
                        name="client"
                        element-name="client"
                        select-value="id"
                        select-label="client_name"
                        @update:value="setClient"
                        :value="filterMutable.client"
                ></interactive-select>
            </div>
        </div>
        <div class="row">
            <div class="text-center">
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-star" aria-hidden="true" title="Ist neu in DE" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.newFlagDe">
                    </label>
                </div>
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-files-o" aria-hidden="true" title="Ist Set-Artikel" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.setFlag">
                    </label>
                </div>
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-retweet" aria-hidden="true" title="Ist NOS-Artikel" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.nosFlag">
                    </label>
                </div>
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-comment" aria-hidden="true" title="Hat Kommentar" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.hasComment">
                    </label>
                </div>
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-ban" aria-hidden="true" title="Gesperrt" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.autosortLock">
                    </label>
                </div>
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-picture-o" aria-hidden="true" title="Hat kein Bild1" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.noFirstImage">
                    </label>
                </div>
                <div class="col-xs-1">
                  <label>
                    <i class="fa fa-child" aria-hidden="true" title="Nachhaltig" data-toggle="tooltip" data-placement="bottom"></i>
                    <input type="checkbox" class="form-control" v-model="filterMutable.isSustainable">
                  </label>
                </div>
                <div class="col-xs-1">
                    <label>
                        <i class="fa fa-check-square-o" aria-hidden="true" title="Nur selektierte anzeigen" data-toggle="tooltip" data-placement="bottom"></i>
                        <input type="checkbox" class="form-control" v-model="filterMutable.selected">
                    </label>
                </div>
            </div>
            <div class="col-md-4 text-center pull-right m-t-md">
                <div class="btn-group btn-group-justified" role="group">
                    <div class="btn-group" role="group">
                        <div class="btn btn-white btn-sm" @click="reset()">
                            <span class="m-r-sm">Zurücksetzen</span>
                            <i class="fa fa-trash"></i>
                        </div>
                    </div>
                    <div class="btn-group" role="group">
                        <div class="btn btn-primary btn-sm" @click="search()">
                            <span class="m-r-sm">Anwenden</span>
                            <i class="fa fa-filter"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
